import { Tabs, TabsProps } from "@mui/material";

const ResponsiveTabs = ({
  centered,
  variant,
  sx = [],
  ...props
}: TabsProps) => (
  <Tabs
    {...props}
    variant={variant === "fullWidth" ? "fullWidth" : "scrollable"}
    scrollButtons="auto"
    allowScrollButtonsMobile
    sx={[
      ...(Array.isArray(sx) ? sx : [sx]),
      { minWidth: 0, maxWidth: "100%" },
      ...(centered
        ? [
            {
              "& .MuiTabs-flexContainer": {
                width: "max-content",
                minWidth: "100%",
                justifyContent: "center",
              },
            },
          ]
        : []),
    ]}
  />
);

export default ResponsiveTabs;
